



















import { Component, Prop, Vue } from "vue-property-decorator";
import { percentFromTotal } from "../../utils";

@Component
export default class ProgressChart extends Vue {
  @Prop() private completionData!: any;
  @Prop() private noUsersAdded!: any;
  private percentFromTotal = percentFromTotal;

  percentage(completed: number, total: number) {
    if (!this.noUsersAdded) {
      return percentFromTotal(completed, total)/2
    } else {
      return 5;
    }
  }

  percentageText(completed: number, total: number) {
    if (!this.noUsersAdded) {
      return percentFromTotal(completed, total)
    } else {
      return 5;
    }
  }
  tooltipLabel(completed: number, total: number) {
    if (completed == null) completed = 0;
    if (!this.noUsersAdded) {
      return completed + "/" + total + " People";
    } else {
      return "";
    }
  }

  get selectedCursor() {
    if (!this.noUsersAdded) {
      return "pointer"
    } else {
      return "default"
    }
  }
  get backgroundColor() {
    if (!this.noUsersAdded) {
      return `#8FEE9E`;
    } else {
      return `#E3E3E3`;
    }
  }
}
